<app-page-header title="PSP Currency" subtitle="Manage currency configurations for payment service providers">
    <div actions class="flex gap-2">
        <p-iconfield>
            <p-inputicon class="pi pi-search" />
            <input type="text" pInputText placeholder="Search" (input)="onGlobalSearch($event)" />
        </p-iconfield>
        <p-button label="Add New" (click)="openCreate()" icon="pi pi-plus"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-table
        #dt
        [value]="currencies"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="['pspType', 'code']"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="id" class="text-left w-[80px]">
                    <div class="flex items-center gap-2">
                        ID
                        <p-sortIcon field="id"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="pspType" class="text-left">
                    <div class="flex items-center gap-2">
                        PSP Type
                        <p-sortIcon field="pspType"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="pspType" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="code" class="text-left">
                    <div class="flex items-center gap-2">
                        Currency Code
                        <p-sortIcon field="code"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="code" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="isActive" class="text-left w-[120px]">
                    <div class="flex items-center gap-2">
                        Status
                        <p-sortIcon field="isActive"></p-sortIcon>
                    </div>
                </th>
                <th class="w-[80px]"></th>
            </tr>
        </ng-template>
        <ng-template #body let-row>
            <tr>
                <td>{{ row.id }}</td>
                <td>{{ row.pspType }}</td>
                <td>{{ row.code }}</td>
                <td>
                    <span [ngClass]="row.isActive ? 'status-badge status-active' : 'status-badge status-inactive'">
                        {{ row.isActive ? 'Active' : 'Inactive' }}
                    </span>
                </td>
                <td class="text-right">
                    <p-button [text]="true" severity="secondary" icon="pi pi-pencil" (click)="openEdit(row)"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog
    [header]="isEditMode ? 'Edit Currency' : 'New Currency'"
    [(visible)]="dialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '450px' }"
>
    <form [formGroup]="currencyForm" (ngSubmit)="saveCurrency()">
        <div class="flex flex-col gap-4">
            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Provider Code *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter provider code"
                    formControlName="providerCode"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('providerCode') }"
                />
                @if (isInvalid('providerCode')) {
                    <small class="text-red-500">Provider code is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Currency Code *</label>
                <p-select
                    [options]="currencyCodes"
                    formControlName="currencyCode"
                    placeholder="Select currency code"
                    appendTo="body"
                    [filter]="true"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('currencyCode') }"
                ></p-select>
                @if (isInvalid('currencyCode')) {
                    <small class="text-red-500">Currency code is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">PSP Type *</label>
                <p-select
                    [options]="pspTypes"
                    formControlName="pspTypeId"
                    optionLabel="text"
                    optionValue="id"
                    placeholder="Select PSP type"
                    [filter]="true"
                    filterBy="text"
                    appendTo="body"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('pspTypeId') }"
                ></p-select>
                @if (isInvalid('pspTypeId')) {
                    <small class="text-red-500">PSP type is required.</small>
                }
            </div>

            @if (isEditMode) {
                <div class="flex items-center gap-2">
                    <p-toggleswitch formControlName="active" inputId="activeToggle"></p-toggleswitch>
                    <label for="activeToggle">Active</label>
                </div>
            }
        </div>
    </form>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" variant="outlined" (click)="cancelDialog()"></p-button>
            <p-button [label]="isEditMode ? 'Update' : 'Create'" (click)="saveCurrency()"></p-button>
        </div>
    </ng-template>
</p-dialog>
